// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatComposer-moduleactions__PtzvI";
var _2 = "GretaAIChatComposer-modulecomposer__TxCgM";
var _3 = "GretaAIChatComposer-moduledisclaimer__FTIjv";
var _4 = "GretaAIChatComposer-moduleinput__NF7bq";
var _5 = "GretaAIChatComposer-moduleroot__PFRpQ";
export { _1 as "actions", _2 as "composer", _3 as "disclaimer", _4 as "input", _5 as "root" }
